"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFromStripeAmount = exports.calculateToStripeAmount = exports.calculateStripeFee = exports.stripeFeeStructure = void 0;
const utils_1 = require("../utils");
const stripeFeesByCountry_1 = require("./stripeFeesByCountry");
const europeanCountryCodes = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'GB',
];
const isEuropeanCountryCode = (countryCode) => europeanCountryCodes.includes(countryCode);
// Exposed for the sake of testing
const stripeFeeStructure = ({ accountCountryCode, cardCountryCode, isSandbox, }) => {
    if (!(0, stripeFeesByCountry_1.isStripeCountry)(accountCountryCode)) {
        throw new Error(`Given country code "${accountCountryCode}" is not supported by Stripe`);
    }
    const accountCountryInformation = (0, stripeFeesByCountry_1.stripeFeesByCountry)(isSandbox)[accountCountryCode];
    const isDomesticCard = accountCountryCode === cardCountryCode ||
        (isEuropeanCountryCode(accountCountryCode) && isEuropeanCountryCode(cardCountryCode));
    if (isDomesticCard) {
        return {
            fixed: accountCountryInformation.fixedFeeDomestic,
            relative: accountCountryInformation.relativeFeeDomestic,
            isDomesticCard,
        };
    }
    return {
        isDomesticCard,
        fixed: accountCountryInformation.fixedFeeInternational,
        relative: accountCountryInformation.relativeFeeInternational,
    };
};
exports.stripeFeeStructure = stripeFeeStructure;
/**
 * Warning!
 * Input and outputs are in cents
 */
const calculateStripeFee = ({ amountCents, accountCountryCode, cardCountryCode, applicationFee = 0, applicationFeeAmountCentsCap = Number.POSITIVE_INFINITY, coverFees = true, isSandbox, }) => {
    if (!amountCents) {
        return {
            totalFeeAmountCents: 0,
            applicationFeeAmountCents: 0,
            providerFeeAmountCents: 0,
        };
    }
    const feeStructure = (0, exports.stripeFeeStructure)({ accountCountryCode, cardCountryCode, isSandbox });
    const nominalApplicationFees = Math.min(amountCents * (applicationFee / 100), applicationFeeAmountCentsCap);
    const nominalProviderFees = feeStructure.fixed + amountCents * (feeStructure.relative / utils_1.CENTS_AMOUNT);
    let totalFeeAmountCents = nominalProviderFees + nominalApplicationFees;
    if (coverFees) {
        const minimalFeeAmountToCover = (0, utils_1.minimalFeeAmountToCoverFees)({
            netAmount: amountCents,
            fees: { relative: feeStructure.relative, fixed: feeStructure.fixed },
        });
        totalFeeAmountCents = Math.max(totalFeeAmountCents, minimalFeeAmountToCover);
    }
    const grossAmountCents = coverFees ? amountCents + totalFeeAmountCents : amountCents;
    const providerFeeAmountCents = feeStructure.fixed + grossAmountCents * (feeStructure.relative / utils_1.CENTS_AMOUNT);
    const applicationFeeAmountCents = totalFeeAmountCents - providerFeeAmountCents;
    return {
        totalFeeAmountCents: Math.round(totalFeeAmountCents),
        applicationFeeAmountCents: Math.round(applicationFeeAmountCents),
        providerFeeAmountCents: Math.round(providerFeeAmountCents),
    };
};
exports.calculateStripeFee = calculateStripeFee;
// @NOTE-AT: see: https://stripe.com/docs/currencies#zero-decimal
const zeroDecimalCurrencies = [
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'JPY',
    'KMF',
    'KRW',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
];
// @NOTE-AT: For zero-decimal currencies, still provide amounts as an integer but without multiplying by 100. For example, to charge ¥500, provide an amount value of 500.
const calculateToStripeAmount = ({ amount, currencyCode = 'USD', }) => {
    if (zeroDecimalCurrencies.includes(currencyCode)) {
        return Number(amount);
    }
    return Number(amount * utils_1.CENTS_AMOUNT);
};
exports.calculateToStripeAmount = calculateToStripeAmount;
// @NOTE-AT: For zero-decimal currencies, still provide amounts as an integer but without multiplying by 100. For example, to charge ¥500, provide an amount value of 500.
const calculateFromStripeAmount = ({ amount, currencyCode = 'USD', }) => {
    if (zeroDecimalCurrencies.includes(currencyCode)) {
        return Number(amount);
    }
    return Number(amount / utils_1.CENTS_AMOUNT);
};
exports.calculateFromStripeAmount = calculateFromStripeAmount;
//# sourceMappingURL=calculateStripeFees.js.map